import { clientApi } from 'api';

export const deleteCountry = (isServer = false) => async (id?: string) => {
  const response = await clientApi.delete(`/countries/${id}`);

  return response;
};
